<template>
    <div class="unavailable-header">
        <p>
            <i class="fa fa-ban"/>
            <span>
                <slot/>
            </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'unavailable-cta',
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables";

    .unavailable-header {
        padding: 17px 10px;
        margin-top: -10px;
        margin-bottom: 5px;
        border-bottom: 1px solid #e2e2e2;
        font-family: @headings-font-family;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        i, span {
            display: inline-block;
            vertical-align: middle;
        }
        i.fa.fa-ban {
            color: #cf4131;
            font-size: 1.5em;
            margin-right: 5px;
        }
        p {
            margin: 0;
        }
    }
</style>
